import { render, staticRenderFns } from "./index_websocket.vue?vue&type=template&id=53d94488&scoped=true&"
import script from "./index_websocket.vue?vue&type=script&lang=js&"
export * from "./index_websocket.vue?vue&type=script&lang=js&"
import style0 from "./index_websocket.vue?vue&type=style&index=0&id=53d94488&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d94488",
  null
  
)

export default component.exports